import { ChangeDetectionStrategy, Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { KeycloakService } from "@mottu-ops/keycloak-angular";
import { TranslateService } from "@mottu-ops/locale";

@Component({
  selector: "access-denied-modal",
  templateUrl: "access-denied-modal.component.html",
  styleUrls: ["access-denied-modal.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccessDeniedModalComponent {
  accessData: AccessDeniedType;

  accessDeniedMessages: Record<FLEET_ACCESS_DENIED_ENUM, AccessDeniedType> = {
    [FLEET_ACCESS_DENIED_ENUM.FLEET_APP_ACCESS]: {
      title: this.translateService.getInstantTranslation('FLEET_ACCESS_DENIED.WEBVIEW_APP.TITLE'),
      message: this.translateService.getInstantTranslation('FLEET_ACCESS_DENIED.WEBVIEW_APP.MESSAGE')
    },
    [FLEET_ACCESS_DENIED_ENUM.FLEET_MONITOR_ACCESS]: {
      title: this.translateService.getInstantTranslation('FLEET_ACCESS_DENIED.MONITOR_FRONT.TITLE'),
      message: this.translateService.getInstantTranslation('FLEET_ACCESS_DENIED.MONITOR_FRONT.MESSAGE')
    },
  };

  defaultAccessDeniedMessage: AccessDeniedType = {
    title: this.translateService.getInstantTranslation('FLEET_ACCESS_DENIED.DEFAULT.TITLE'),
    message: this.translateService.getInstantTranslation('FLEET_ACCESS_DENIED.DEFAULT.MESSAGE')
  };

  constructor(
    private keycloakService: KeycloakService,
    private translateService: TranslateService,
    private dialogRef: MatDialogRef<AccessDeniedModalComponent>,
    @Inject(MAT_DIALOG_DATA) public accessType: FLEET_ACCESS_DENIED_ENUM | AccessDeniedType | null) {
    if (accessType && typeof accessType === 'object' && 'title' in accessType && 'message' in accessType) {
      this.accessData = accessType;
    } else {
      this.accessData = this.accessDeniedMessages[accessType as FLEET_ACCESS_DENIED_ENUM] || this.defaultAccessDeniedMessage;
    }
  }

  onOkClick(): void {
    this.dialogRef.close();
    if (this.accessData.shouldLogout !== false) {
      this.logout();
    }
  }

  private logout(): void {
    this.keycloakService.logout();
  }
}

export enum FLEET_ACCESS_DENIED_ENUM {
  FLEET_MONITOR_ACCESS = 'FLEET_MONITOR_ACCESS',
  FLEET_APP_ACCESS = 'FLEET_APP_ACCESS',
}

interface AccessDeniedType {
  title: string;
  message: string;
  shouldLogout?: boolean;
}
